<template>
  <section id="download-ark-store">
    <div class="container">
      <div class="row wrapper">
        <div
          class="col-12 col-md-12 col-xl-6 d-flex justify-content-center flex-column"
        >
          <p class="download-text">
            Enjoy smartest and quality healthcare solutions at an affordable
            price.
          </p>
          <div class="store-wrapper mb-3">
            <a href="">
              <img :src="playStore" alt="" />
            </a>
            <a href="">
              <img :src="appStore" alt="" class="appstore-img" />
            </a>
          </div>
        </div>
        <div class="col-12 col-md-12 col-xl-6">
          <div class="image-wrapper">
            <img :src="Phone" alt="" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "DownloadArkStore",
  setup() {
    const appStore = "/img/appstore.png";
    const playStore = "/img/googleplay.png";
    const Phone = "/img/iPhone_13.png";

    return {
      appStore,
      playStore,
      Phone,
    };
  },
};
</script>
<style scoped>
#download-ark-store {
  background-color: var(--Cerulean);
  padding: 96px 0;
}
.download-text {
  font-size: var(--fs-48);
  font-weight: var(--fw-700);
  color: #fff;
  margin-bottom: 32px;
}
.store-wrapper {
  display: flex;
  gap: 2rem;
}
.image-wrapper {
  display: flex;
  justify-content: flex-end;
}

/* MEDIA STYLING BASED ON BOOTSTRAP STANDARD */
@media screen and (max-width: 767px) {
  .wrapper {
    flex-direction: column-reverse;
  }
  .download-text {
    text-align: center;
    font-size: 38px;
  }
  .store-wrapper {
    flex-direction: column;
    gap: 1rem;
  }
  .store-wrapper a > img {
    width: 100%;
  }
  .appstore-img {
    margin-top: 16px;
  }
  .image-wrapper > img {
    width: 100%;
    height: 100%;
  }
}

@media screen and (min-width: 767px) and (max-width: 1200px) {
  .wrapper {
    flex-direction: column;
  }
  .download-text {
    width: 100% !important;
    text-align: center;
  }
  .store-wrapper {
    justify-content: center;
  }
  .image-wrapper {
    justify-content: center;
    margin-top: 30px;
  }
}
</style>
